var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 130,
    viewBox: "0 0 171 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.961426,
    y: 0.162369,
    width: 169.5,
    height: 129.25,
    rx: 8,
    fill: "#C6CEDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6443 55.2747C73.6488 54.6255 74.1736 54.1001 74.8228 54.095H96.227C96.878 54.095 97.4055 54.6237 97.4055 55.2747V74.3004C97.401 74.9496 96.8762 75.4749 96.227 75.4801H74.8228C74.1718 75.4795 73.6443 74.9515 73.6443 74.3004V55.2747ZM95.0295 56.4712H76.0205V73.104L87.06 62.0622C87.524 61.5984 88.276 61.5984 88.74 62.0622L95.0295 68.3636V56.4712ZM78.3964 61.2233C78.3964 62.5356 79.4602 63.5994 80.7725 63.5994C82.0848 63.5994 83.1486 62.5356 83.1486 61.2233C83.1486 59.911 82.0848 58.8472 80.7725 58.8472C79.4602 58.8472 78.3964 59.911 78.3964 61.2233Z",
    fill: "#E8EBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogue);
export default __webpack_public_path__ + "static/media/catalogue.6b45e7eaba186c3d2f08b4ec59d5d597.svg";
export { ForwardRef as ReactComponent };